import { MultiSelect } from 'primereact/multiselect';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import './style.css';

export const HeaderTable = ({
  companies,
  handleCompanySelectChange,
  defaultCompany // string: instanceId
}) => {
  const defaultCompanyObj = useMemo(
    () => companies.find((c) => c.instanceId === defaultCompany),
    [companies, defaultCompany]
  );

  const [selectedCompanies, setSelectedCompanies] = useState(() =>
    defaultCompanyObj ? [defaultCompanyObj] : []
  );

  const defaultAssignedRef = useRef(false);

  useEffect(() => {
    const unique = selectedCompanies.filter(
      (c, i, self) => self.findIndex((x) => x.instanceId === c.instanceId) === i
    );

    if (!defaultAssignedRef.current && unique.length === 0 && defaultCompanyObj) {
      setSelectedCompanies([defaultCompanyObj]);
      defaultAssignedRef.current = true;
      return;
    }

    handleCompanySelectChange?.(unique);
  }, [selectedCompanies, defaultCompanyObj]);

  const handleChange = (e) => {
    const resolved = (e.value || [])
      .map((s) => companies.find((c) => c.instanceId === s.instanceId))
      .filter(Boolean);

    const unique = resolved.filter(
      (c, i, self) => self.findIndex((x) => x.instanceId === c.instanceId) === i
    );

    if (unique.length === 0 && defaultCompanyObj) {
      unique.push(defaultCompanyObj);
    }

    setSelectedCompanies(unique);
  };

  const itemTemplate = (option) => (
    <span>{option.name} ({option.alias?.trim() ? option.alias : '-'})</span>
  );

  const valueTemplate = (selectedOptions, props) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      return <span className="p-multiselect-placeholder">{props.placeholder}</span>;
    }
    if (selectedOptions.length === 1) {
      const o = selectedOptions[0];
      return (
        <span>
          {o.name} ({o.alias?.trim() ? o.alias : '-'})
        </span>
      );
    }
    return <span>{`${selectedOptions.length} empresas seleccionadas`}</span>;
  };


  // Header personalizado con botón seleccionar/deseleccionar todas
  const customPanelHeader = () => {
    const allSelected = selectedCompanies.length === companies.length;

    const toggleAll = () => {
      if (allSelected) {
        setSelectedCompanies([defaultCompanyObj]);
      } else {
        setSelectedCompanies([...companies]);
      }
    };

    return (
      <div className="flex items-center justify-between px-2 py-1 gap-2">
        <button
          type="button"
          className="text-sm text-blue-600 hover:underline"
          onClick={toggleAll}
        >
          {allSelected ? 'Deseleccionar todas' : 'Seleccionar todas'}
        </button>
      </div>
    );
  };

  return (
    <div className="flex flex-wrap items-start gap-2 w-full px-2">
      <label className="font-bold text-sm whitespace-nowrap mt-2">
        Aplicar a las siguientes empresas
      </label>

      <div className="flex-1 min-w-[250px]">
        <MultiSelect
          value={selectedCompanies}
          onChange={handleChange}
          options={companies}
          optionLabel="name"
          dataKey="instanceId"
          className="w-full min-h-[48px]"
          placeholder="Selecciona las empresas deseadas"
          display="comma"
          maxSelectedLabels={1}
          selectedItemsLabel="{0} empresas seleccionadas"
          filter
          showSelectAll
          panelHeaderTemplate={customPanelHeader}
          emptyMessage="No se encontraron resultados"
          itemTemplate={itemTemplate} 
          valueTemplate={valueTemplate}
        />
      </div>
    </div>
  );
};